import React from 'react';
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

export const Unauthorized: React.FC = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: '60vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                px: 2,
                textAlign: 'center',
                mt: { xs: 8, sm: 12 },
            }}
        >
            <ReportProblemIcon sx={{ fontSize: { xs: 60, sm: 80 }, color: theme.palette.error.main, mb: 2 }} />
            <Typography variant="h3" color="error" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: '2rem', sm: '3rem' } }}>
                Unauthorized
            </Typography>
            <Typography variant="h5" color="textSecondary" sx={{ mb: 1, fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                You are not authorized to access the requested resource.
            </Typography>
            <Typography variant="h6" color="textSecondary" sx={{ fontSize: { xs: '1rem', sm: '1.2rem' } }}>
                If you believe you received this message in error, please contact your security administrator for support.
            </Typography>
        </Box>
    );
}
